var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-hover table-sm trace_table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.trace, function (record, index) {
          return _c("tr", [
            _c("td", [_vm._v(_vm._s(index + 1))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.actions[record.action_id]))]),
            _vm._v(" "),
            _c("td", [
              _c(
                "div",
                { staticClass: "flex" },
                [
                  record.action_id === 49
                    ? [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c(
                              "v-popover",
                              {
                                attrs: {
                                  popoverClass: "popover_trace_letter_body",
                                  placement: "right",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-info info_fa",
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "popover" }, [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        record.data.letter.body
                                      ),
                                    },
                                  }),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  record.action_id === 67
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-xs btn-info ml-1 mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.showTask(record.int_value)
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                        ),
                        _vm._v("\n            Задача: "),
                        _c("strong", [_vm._v(_vm._s(record.int_value))]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.printDataByAction(record.action_id, record)
                      ),
                    },
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                record.user_id
                  ? [
                      _vm._v(
                        "(" +
                          _vm._s(record.user_id) +
                          ") " +
                          _vm._s(record.user ? record.user.name : null)
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(_vm.printDate(record.created_at, "DD.MM.YYYY HH:mm"))
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "30" } }),
        _vm._v(" "),
        _c("th", [_vm._v("Операция")]),
        _vm._v(" "),
        _c("th", [_vm._v("Информация")]),
        _vm._v(" "),
        _c("th", [_vm._v("Пользователь")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }